const initials = require('~/config').initials;
import VueI18n from 'vue-i18n';
import Vue from 'vue';

import koKr from './locales/ko-kr.yml';
import enUs from './locales/en-us.yml';
import zaJp from './locales/za-jp.yml';
import zhCn from './locales/zh-cn.yml';
import zhTw from './locales/zh-tw.yml';

import DateFormat from './date-format';
import Currency from './currency';

Vue.use(VueI18n);

export function createI18n() {
  return new VueI18n({
    locale: initials.locale,
    fallbackLocale: initials.fallbackLocale,
    dateTimeFormats: DateFormat,
    numberFormats: Currency,
    messages: {
      'ko': koKr,
      'en': enUs,
      'ja': zaJp,
      'zh-cn': zhCn,
      'zh-tw': zhTw
    }
  });
}
